// Auto-generated resource for RecentPractices — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const RecentPracticesKeys = {
  Heading: 'RecentPractices.Heading',
  Subhead: 'RecentPractices.Subhead',
  Loading: 'RecentPractices.Loading',
  LoadError: 'RecentPractices.LoadError',
  OnDeviceStorageNote: 'RecentPractices.OnDeviceStorageNote',
  OnDeviceClearsIn: 'RecentPractices.OnDeviceClearsIn',
  ClaimTitle: 'RecentPractices.ClaimTitle',
  ClaimLibraryBody: 'RecentPractices.ClaimLibraryBody',
  ClaimLibraryCta: 'RecentPractices.ClaimLibraryCta',
  EmptyLibrary: 'RecentPractices.EmptyLibrary',
  RecordingRemoved: 'RecentPractices.RecordingRemoved',
  MoreDetails: 'RecentPractices.MoreDetails',
  MoreActionsAria: 'RecentPractices.MoreActionsAria',
  Download: 'RecentPractices.Download',
  Preparing: 'RecentPractices.Preparing',
  ReviewedPill: 'RecentPractices.ReviewedPill',
  ReviewedPillTitle: 'RecentPractices.ReviewedPillTitle',
  LocalBadge: 'RecentPractices.LocalBadge',
  RemovalCountdownOne: 'RecentPractices.RemovalCountdownOne',
  RemovalCountdownMany: 'RecentPractices.RemovalCountdownMany',
  PlanSavedToLibrary: 'RecentPractices.PlanSavedToLibrary',
  PlanHeldWhileNewPlanRuns: 'RecentPractices.PlanHeldWhileNewPlanRuns',
  PlanKeptUntil: 'RecentPractices.PlanKeptUntil',
  RemovalHint: 'RecentPractices.RemovalHint',
  RemovalHintLabel: 'RecentPractices.RemovalHintLabel',
  DownloadUnavailable: 'RecentPractices.DownloadUnavailable',
  RecordingNotOnDevice: 'RecentPractices.RecordingNotOnDevice',
  DownloadError: 'RecentPractices.DownloadError',
  DetailLoading: 'RecentPractices.DetailLoading',
  DetailFetchError: 'RecentPractices.DetailFetchError',
  PracticeText: 'RecentPractices.PracticeText',
  Notes: 'RecentPractices.Notes',
  NotePlaceholder: 'RecentPractices.NotePlaceholder',
  SaveNote: 'RecentPractices.SaveNote',
  Saving: 'RecentPractices.Saving',
  SaveNoteError: 'RecentPractices.SaveNoteError',
  AiReviewsHeading: 'RecentPractices.AiReviewsHeading',
  NoReviews: 'RecentPractices.NoReviews',
  ReplayAria: 'RecentPractices.ReplayAria',
  ReplayThumbnailAlt: 'RecentPractices.ReplayThumbnailAlt',
  AiReviewAction: 'RecentPractices.AiReviewAction',
  AiReviewUploading: 'RecentPractices.AiReviewUploading',
  AiReviewTooltipTooShort: 'RecentPractices.AiReviewTooltipTooShort',
  AiReviewTooltipNoCredits: 'RecentPractices.AiReviewTooltipNoCredits',
  AiReviewTooltipRemoved: 'RecentPractices.AiReviewTooltipRemoved',
  AiReviewTooltipNotReviewable: 'RecentPractices.AiReviewTooltipNotReviewable',
  AiReviewError: 'RecentPractices.AiReviewError',
  ReviewFailedTitle: 'RecentPractices.ReviewFailedTitle',
  ReviewFailedNoCharge: 'RecentPractices.ReviewFailedNoCharge',
  ReviewFailedOurSideBody: 'RecentPractices.ReviewFailedOurSideBody',
  ReviewFailedRetry: 'RecentPractices.ReviewFailedRetry',
  ReviewFailedTooShortBody: 'RecentPractices.ReviewFailedTooShortBody',
  ReviewFailedTooLongBody: 'RecentPractices.ReviewFailedTooLongBody',
  ReviewFailedReRecord: 'RecentPractices.ReviewFailedReRecord',
  ReviewFailedNeverUploadedBody: 'RecentPractices.ReviewFailedNeverUploadedBody',
  ReviewFailedRecordingGoneBody: 'RecentPractices.ReviewFailedRecordingGoneBody',
  ReviewFailedNoCreditsBody: 'RecentPractices.ReviewFailedNoCreditsBody',
  ReviewFailedTopUp: 'RecentPractices.ReviewFailedTopUp',
  Save: 'RecentPractices.Save',
  SaveTitle: 'RecentPractices.SaveTitle',
  Saved: 'RecentPractices.Saved',
  SaveError: 'RecentPractices.SaveError',
  SaveQuotaError: 'RecentPractices.SaveQuotaError',
  Discard: 'RecentPractices.Discard',
  Discarding: 'RecentPractices.Discarding',
  DiscardError: 'RecentPractices.DiscardError',
  RenameTakeAria: 'RecentPractices.RenameTakeAria',
  RenameError: 'RecentPractices.RenameError',
  ReplaceThumbnail: 'RecentPractices.ReplaceThumbnail',
  ScrubAria: 'RecentPractices.ScrubAria',
  UseThisFrame: 'RecentPractices.UseThisFrame',
  ScrubCancel: 'RecentPractices.ScrubCancel',
  ThumbnailUploadError: 'RecentPractices.ThumbnailUploadError',
  CleanUp: 'RecentPractices.CleanUp',
  CleanUpConfirmTitle: 'RecentPractices.CleanUpConfirmTitle',
  CleanUpConfirmBody: 'RecentPractices.CleanUpConfirmBody',
  CleanUpConfirm: 'RecentPractices.CleanUpConfirm',
  CleanUpCancel: 'RecentPractices.CleanUpCancel',
  CleanUpNone: 'RecentPractices.CleanUpNone',
  CleanUpDoneOne: 'RecentPractices.CleanUpDoneOne',
  CleanUpDoneMany: 'RecentPractices.CleanUpDoneMany',
  PremiumLibraryHint: 'RecentPractices.PremiumLibraryHint',
  PremiumLibraryHintLink: 'RecentPractices.PremiumLibraryHintLink',
  PracticeTextDownloadError: 'RecentPractices.PracticeTextDownloadError',
  PracticeAgain: 'RecentPractices.PracticeAgain',
  NotOnDeviceBody: 'RecentPractices.NotOnDeviceBody',
  NoReviewsHint: 'RecentPractices.NoReviewsHint',
  OpenSeries: 'RecentPractices.OpenSeries',
  EmptyTitle: 'RecentPractices.EmptyTitle',
  EmptyFiltered: 'RecentPractices.EmptyFiltered',
  RangeAria: 'RecentPractices.RangeAria',
  RangeLast7: 'RecentPractices.RangeLast7',
  RangeLast30: 'RecentPractices.RangeLast30',
  RangeAll: 'RecentPractices.RangeAll',
  RangeCustom: 'RecentPractices.RangeCustom',
  RangeCustomOption: 'RecentPractices.RangeCustomOption',
  RangeCustomValue: 'RecentPractices.RangeCustomValue',
  RangeFrom: 'RecentPractices.RangeFrom',
  RangeTo: 'RecentPractices.RangeTo',
  RangeClose: 'RecentPractices.RangeClose',
  FiltersAria: 'RecentPractices.FiltersAria',
  FilterShow: 'RecentPractices.FilterShow',
  FilterEverything: 'RecentPractices.FilterEverything',
  FilterWhereGroup: 'RecentPractices.FilterWhereGroup',
  FilterOnDevice: 'RecentPractices.FilterOnDevice',
  FilterPlan: 'RecentPractices.FilterPlan',
  FilterSaved: 'RecentPractices.FilterSaved',
  FilterReviewed: 'RecentPractices.FilterReviewed',
  FilterPracticesGroup: 'RecentPractices.FilterPracticesGroup',
  TakesAria: 'RecentPractices.TakesAria',
  DayToday: 'RecentPractices.DayToday',
  DayYesterday: 'RecentPractices.DayYesterday',
  MonthRailAria: 'RecentPractices.MonthRailAria',
  BackToTop: 'RecentPractices.BackToTop',
  BackToLibrary: 'RecentPractices.BackToLibrary',
  TakeClose: 'RecentPractices.TakeClose',
  TakePrevious: 'RecentPractices.TakePrevious',
  TakeNext: 'RecentPractices.TakeNext',
  OpenFullDetails: 'RecentPractices.OpenFullDetails',
  TakeStoredOnDevice: 'RecentPractices.TakeStoredOnDevice',
  TakeStoredInCloud: 'RecentPractices.TakeStoredInCloud',
  SelectToggle: 'RecentPractices.SelectToggle',
  SelectDone: 'RecentPractices.SelectDone',
  SelectTakeAria: 'RecentPractices.SelectTakeAria',
  SelectionAria: 'RecentPractices.SelectionAria',
  SelectedCount: 'RecentPractices.SelectedCount',
  SelectAll: 'RecentPractices.SelectAll',
  SelectClear: 'RecentPractices.SelectClear',
  BulkSave: 'RecentPractices.BulkSave',
  BulkDelete: 'RecentPractices.BulkDelete',
  BulkWorking: 'RecentPractices.BulkWorking',
  BulkDeleteTitleOne: 'RecentPractices.BulkDeleteTitleOne',
  BulkDeleteTitleMany: 'RecentPractices.BulkDeleteTitleMany',
  BulkDeleteBody: 'RecentPractices.BulkDeleteBody',
  BulkDeleteSkipNote: 'RecentPractices.BulkDeleteSkipNote',
  BulkDeleteConfirm: 'RecentPractices.BulkDeleteConfirm',
  BulkCancel: 'RecentPractices.BulkCancel',
  BulkDeleted: 'RecentPractices.BulkDeleted',
  BulkDeletedFailed: 'RecentPractices.BulkDeletedFailed',
  BulkDownloaded: 'RecentPractices.BulkDownloaded',
  BulkDownloadedFailed: 'RecentPractices.BulkDownloadedFailed',
  BulkSaving: 'RecentPractices.BulkSaving',
  BulkSavingFailed: 'RecentPractices.BulkSavingFailed',
  BulkSkippedPending: 'RecentPractices.BulkSkippedPending',
  BulkSaveSkipped: 'RecentPractices.BulkSaveSkipped',
  BulkRetry: 'RecentPractices.BulkRetry',
} as const;

export const RecentPracticesValues = {
  'default': {
    'AiReviewAction': 'AI Review',
    'AiReviewError': 'Could not start the AI Review. Please try again.',
    'AiReviewTooltipNoCredits': 'You\'re out of AI credits — add credits to run a review.',
    'AiReviewTooltipNotReviewable': 'This practice doesn\'t support AI Review.',
    'AiReviewTooltipRemoved': 'The recording has been removed, so it can\'t be sent for review.',
    'AiReviewTooltipTooShort': 'AI Review needs a recording at least {MinSeconds} seconds long.',
    'AiReviewUploading': 'Uploading…',
    'AiReviewsHeading': 'AI Reviews',
    'BackToLibrary': 'Back to My library',
    'BackToTop': 'Back to top',
    'BulkCancel': 'Cancel',
    'BulkDelete': 'Discard',
    'BulkDeleteBody': 'In your library: {Stored} · On this device: {Device}. Library takes are deleted for good and on-device takes are removed from this browser. Completed AI Reviews stay.',
    'BulkDeleteConfirm': 'Discard',
    'BulkDeleteSkipNote': '{Skipped} of {Total} are still saving and are left alone.',
    'BulkDeleteTitleMany': 'Discard {Count} takes?',
    'BulkDeleteTitleOne': 'Discard {Count} take?',
    'BulkDeleted': '{Done} discarded',
    'BulkDeletedFailed': '{Done} discarded, {Failed} failed',
    'BulkDownloaded': '{Done} downloaded',
    'BulkDownloadedFailed': '{Done} downloaded, {Failed} failed',
    'BulkRetry': 'Retry failed',
    'BulkSave': 'Save to library',
    'BulkSaveSkipped': 'Save to library: {Skipped} of {Total} are already saved or not on this device',
    'BulkSaving': '{Done} saving to your library',
    'BulkSavingFailed': '{Done} saving to your library, {Failed} failed',
    'BulkSkippedPending': '{Skipped} of {Total} are still saving and were skipped',
    'BulkWorking': 'Working…',
    'ClaimLibraryBody': 'Create your account to keep AI-reviewed takes and save takes to your library.',
    'ClaimLibraryCta': 'Create my account',
    'ClaimTitle': 'Save your progress',
    'CleanUp': 'Clean up abandoned takes',
    'CleanUpCancel': 'Cancel',
    'CleanUpConfirm': 'Clean up abandoned takes',
    'CleanUpConfirmBody': 'This deletes every take under {MaxSeconds} seconds saved on this browser. This can\'t be undone.',
    'CleanUpConfirmTitle': 'Clean up abandoned takes',
    'CleanUpDoneMany': 'Removed {Count} abandoned takes.',
    'CleanUpDoneOne': 'Removed {Count} abandoned take.',
    'CleanUpNone': 'No abandoned takes to clean up.',
    'DayToday': 'Today · {Date}',
    'DayYesterday': 'Yesterday · {Date}',
    'DetailFetchError': 'Could not load this session’s details.',
    'DetailLoading': 'Loading details…',
    'Discard': 'Discard',
    'DiscardError': 'Could not discard this take. Please try again.',
    'Discarding': 'Discarding…',
    'Download': 'Download',
    'DownloadError': 'Could not prepare that download. Please try again.',
    'DownloadUnavailable': 'That recording is no longer available to download.',
    'EmptyFiltered': 'No takes match this range and filter.',
    'EmptyLibrary': 'No takes yet. Record a practice and your take shows up here.',
    'EmptyTitle': 'Nothing here yet',
    'FilterEverything': 'Everything',
    'FilterOnDevice': 'On this device',
    'FilterPlan': 'Mastery plan',
    'FilterPracticesGroup': 'Practices',
    'FilterReviewed': 'Reviewed',
    'FilterSaved': 'Saved',
    'FilterShow': 'Show',
    'FilterWhereGroup': 'Where it lives',
    'FiltersAria': 'Filters',
    'Heading': 'My library',
    'LoadError': 'Could not load your library.',
    'Loading': 'Loading your library…',
    'LocalBadge': 'on this browser',
    'MonthRailAria': 'Jump to month',
    'MoreActionsAria': 'More actions for “{Name}”',
    'MoreDetails': 'More details',
    'NoReviews': 'No AI Reviews for this take yet.',
    'NoReviewsHint': 'Get AI Review above sends this take for feedback.',
    'NotOnDeviceBody': 'A take that was never saved lives only in the browser that recorded it, for {Days} days.',
    'NotePlaceholder': 'Add a private note about this take…',
    'Notes': 'Notes',
    'OnDeviceClearsIn': 'Clears in {Time}',
    'OnDeviceStorageNote': 'Takes on this device are kept in this browser’s storage for {Days} days. Anyone using this browser can see them, and they aren’t tied to your account — so delete any you don’t want to keep.',
    'OpenFullDetails': 'Open full details',
    'OpenSeries': 'Open this take\'s series',
    'PlanHeldWhileNewPlanRuns': 'Kept while your new plan runs',
    'PlanKeptUntil': 'Kept until {Date}',
    'PlanSavedToLibrary': 'Saved to library',
    'PracticeAgain': 'Practice again',
    'PracticeText': 'Practice text',
    'PracticeTextDownloadError': 'Could not include the practice text with that download.',
    'PremiumLibraryHint': 'Upgrade to Premium to keep takes in your library.',
    'PremiumLibraryHintLink': 'See plans',
    'Preparing': 'Preparing…',
    'RangeAll': 'All time',
    'RangeAria': 'Date range',
    'RangeClose': 'Close',
    'RangeCustom': 'Custom range',
    'RangeCustomOption': 'Custom range…',
    'RangeCustomValue': 'Custom: {From} – {To}',
    'RangeFrom': 'From',
    'RangeLast30': 'Last 30 days',
    'RangeLast7': 'Last 7 days',
    'RangeTo': 'To',
    'RecordingNotOnDevice': 'That recording isn’t on this device.',
    'RecordingRemoved': 'Recording has been removed',
    'RemovalCountdownMany': 'The recording will be removed in {Days} days per our retention policy.',
    'RemovalCountdownOne': 'The recording will be removed in {Days} day per our retention policy.',
    'RemovalHint': 'You can download the recording to keep it, or adjust your auto-delete setting.',
    'RemovalHintLabel': 'Retention details',
    'RenameError': 'Could not rename this take. Please try again.',
    'RenameTakeAria': 'Rename “{Name}”',
    'ReplaceThumbnail': 'Replace thumbnail',
    'ReplayAria': 'Play this recording',
    'ReplayThumbnailAlt': 'Take thumbnail — tap to play',
    'ReviewFailedNeverUploadedBody': 'This review never ran — the recording was never uploaded. Record the take again to review it.',
    'ReviewFailedNoCharge': 'No credits were kept — anything reserved was refunded.',
    'ReviewFailedNoCreditsBody': 'You didn\'t have enough AI credits to finish this review. Top up, then run it again.',
    'ReviewFailedOurSideBody': 'This one\'s on us — the review didn\'t finish because of a problem on our side, not your take.',
    'ReviewFailedReRecord': 'Re-record',
    'ReviewFailedRecordingGoneBody': 'This review never ran — the recording was deleted first. Record the take again to review it.',
    'ReviewFailedRetry': 'Re-review',
    'ReviewFailedTitle': 'AI Review didn\'t finish',
    'ReviewFailedTooLongBody': 'This take is {Measured}, over the {MaxMinutes}-minute maximum for a review. Trim it and record again.',
    'ReviewFailedTooShortBody': 'This take is {Measured}, under the {MinSeconds}-second minimum for a review. Record a longer take and try again.',
    'ReviewFailedTopUp': 'Top up credits',
    'ReviewedPill': '★ Reviewed',
    'ReviewedPillTitle': 'AI Review available',
    'Save': 'Save',
    'SaveError': 'Could not save this take. Please try again.',
    'SaveNote': 'Save note',
    'SaveNoteError': 'Could not save your note. Please try again.',
    'SaveQuotaError': 'You\'re out of storage — use Add storage above, or clean up some takes, then try again.',
    'SaveTitle': 'Save to my library',
    'Saved': 'Saved',
    'Saving': 'Saving…',
    'ScrubAria': 'Scrub to a frame for the thumbnail',
    'ScrubCancel': 'Cancel',
    'SelectAll': 'Select all',
    'SelectClear': 'Clear selection',
    'SelectDone': 'Done',
    'SelectTakeAria': 'Select “{Name}”',
    'SelectToggle': 'Select',
    'SelectedCount': '{Count} selected',
    'SelectionAria': 'Selected takes',
    'Subhead': 'Every take you’ve recorded — on this device, in your mastery plan, saved and reviewed.',
    'TakeClose': 'Close',
    'TakeNext': 'Next take',
    'TakePrevious': 'Previous take',
    'TakeStoredInCloud': 'Stored in your cloud library',
    'TakeStoredOnDevice': 'Stored on this device',
    'TakesAria': 'Takes',
    'ThumbnailUploadError': 'Could not update the thumbnail. Please try again.',
    'UseThisFrame': 'Use this frame',
  },
  'vi-VN': {
    'AiReviewAction': 'Đánh giá AI',
    'AiReviewError': 'Không thể bắt đầu Đánh giá AI. Vui lòng thử lại.',
    'AiReviewTooltipNoCredits': 'Bạn đã hết tín dụng AI — hãy thêm tín dụng để chạy đánh giá.',
    'AiReviewTooltipNotReviewable': 'Bài luyện này không hỗ trợ Đánh giá AI.',
    'AiReviewTooltipRemoved': 'Bản thu đã bị xóa nên không thể gửi để đánh giá.',
    'AiReviewTooltipTooShort': 'Đánh giá AI cần một bản thu dài ít nhất {MinSeconds} giây.',
    'AiReviewUploading': 'Đang tải lên…',
    'AiReviewsHeading': 'Đánh giá AI',
    'BackToLibrary': 'Quay lại Thư viện của tôi',
    'BackToTop': 'Lên đầu trang',
    'BulkCancel': 'Hủy',
    'BulkDelete': 'Loại bỏ',
    'BulkDeleteBody': 'Trong thư viện: {Stored} · Trên thiết bị này: {Device}. Lượt trong thư viện bị xóa vĩnh viễn, lượt trên thiết bị bị gỡ khỏi trình duyệt này. Các AI Review đã hoàn tất vẫn được giữ.',
    'BulkDeleteConfirm': 'Loại bỏ',
    'BulkDeleteSkipNote': '{Skipped} trên {Total} lượt vẫn đang lưu nên được giữ nguyên.',
    'BulkDeleteTitleMany': 'Loại bỏ {Count} lượt?',
    'BulkDeleteTitleOne': 'Loại bỏ {Count} lượt?',
    'BulkDeleted': 'Đã loại bỏ {Done}',
    'BulkDeletedFailed': 'Đã loại bỏ {Done}, {Failed} thất bại',
    'BulkDownloaded': 'Đã tải xuống {Done}',
    'BulkDownloadedFailed': 'Đã tải xuống {Done}, {Failed} thất bại',
    'BulkRetry': 'Thử lại mục lỗi',
    'BulkSave': 'Lưu vào thư viện',
    'BulkSaveSkipped': 'Lưu vào thư viện: {Skipped} trên {Total} lượt đã được lưu hoặc không có trên thiết bị này',
    'BulkSaving': 'Đang lưu {Done} vào thư viện',
    'BulkSavingFailed': 'Đang lưu {Done} vào thư viện, {Failed} thất bại',
    'BulkSkippedPending': '{Skipped} trên {Total} lượt vẫn đang lưu nên đã bỏ qua',
    'BulkWorking': 'Đang xử lý…',
    'ClaimLibraryBody': 'Tạo tài khoản của bạn để giữ các lượt đã đánh giá AI và lưu các lượt vào thư viện.',
    'ClaimLibraryCta': 'Tạo tài khoản của tôi',
    'ClaimTitle': 'Lưu tiến trình của bạn',
    'CleanUp': 'Dọn các lượt bỏ dở',
    'CleanUpCancel': 'Hủy',
    'CleanUpConfirm': 'Dọn các lượt bỏ dở',
    'CleanUpConfirmBody': 'Thao tác này xóa mọi lượt dưới {MaxSeconds} giây đã lưu trên trình duyệt này. Không thể hoàn tác.',
    'CleanUpConfirmTitle': 'Dọn các lượt bỏ dở',
    'CleanUpDoneMany': 'Đã xóa {Count} lượt bỏ dở.',
    'CleanUpDoneOne': 'Đã xóa {Count} lượt bỏ dở.',
    'CleanUpNone': 'Không có lượt bỏ dở nào để dọn.',
    'DayToday': 'Hôm nay · {Date}',
    'DayYesterday': 'Hôm qua · {Date}',
    'DetailFetchError': 'Không thể tải chi tiết của phiên này.',
    'DetailLoading': 'Đang tải chi tiết…',
    'Discard': 'Loại bỏ',
    'DiscardError': 'Không thể loại bỏ lượt này. Vui lòng thử lại.',
    'Discarding': 'Đang loại bỏ…',
    'Download': 'Tải xuống',
    'DownloadError': 'Không thể chuẩn bị tải xuống. Vui lòng thử lại.',
    'DownloadUnavailable': 'Bản thu đó không còn khả dụng để tải xuống.',
    'EmptyFiltered': 'Không có lượt nào khớp với khoảng thời gian và bộ lọc này.',
    'EmptyLibrary': 'Chưa có lượt nào. Hãy luyện tập và lượt thu của bạn sẽ hiện ở đây.',
    'EmptyTitle': 'Chưa có gì ở đây',
    'FilterEverything': 'Tất cả',
    'FilterOnDevice': 'Trên thiết bị này',
    'FilterPlan': 'Kế hoạch thành thạo',
    'FilterPracticesGroup': 'Bài luyện',
    'FilterReviewed': 'Đã đánh giá',
    'FilterSaved': 'Đã lưu',
    'FilterShow': 'Hiển thị',
    'FilterWhereGroup': 'Lưu ở đâu',
    'FiltersAria': 'Bộ lọc',
    'Heading': 'Thư viện của tôi',
    'LoadError': 'Không thể tải thư viện của bạn.',
    'Loading': 'Đang tải thư viện của bạn…',
    'LocalBadge': 'trên trình duyệt này',
    'MonthRailAria': 'Chuyển đến tháng',
    'MoreActionsAria': 'Tác vụ khác cho “{Name}”',
    'MoreDetails': 'Chi tiết',
    'NoReviews': 'Chưa có Đánh giá AI nào cho lượt này.',
    'NoReviewsHint': 'Nút Đánh giá AI ở trên sẽ gửi lượt này để nhận nhận xét.',
    'NotOnDeviceBody': 'Một lượt chưa được lưu chỉ nằm trong trình duyệt đã ghi nó, trong {Days} ngày.',
    'NotePlaceholder': 'Thêm ghi chú riêng tư về lượt này…',
    'Notes': 'Ghi chú',
    'OnDeviceClearsIn': 'Xóa sau {Time}',
    'OnDeviceStorageNote': 'Các lượt trên thiết bị này được lưu trong bộ nhớ của trình duyệt này trong {Days} ngày. Ai dùng trình duyệt này cũng xem được chúng, và chúng không gắn với tài khoản của bạn — hãy xóa những lượt bạn không muốn giữ.',
    'OpenFullDetails': 'Mở toàn bộ chi tiết',
    'OpenSeries': 'Mở chuỗi của lượt này',
    'PlanHeldWhileNewPlanRuns': 'Được giữ trong khi kế hoạch mới của bạn đang chạy',
    'PlanKeptUntil': 'Giữ đến {Date}',
    'PlanSavedToLibrary': 'Đã lưu vào thư viện',
    'PracticeAgain': 'Luyện tập lại',
    'PracticeText': 'Nội dung luyện tập',
    'PracticeTextDownloadError': 'Không thể kèm nội dung bài luyện vào tệp tải xuống đó.',
    'PremiumLibraryHint': 'Nâng cấp lên Premium để giữ các lượt trong thư viện của bạn.',
    'PremiumLibraryHintLink': 'Xem các gói',
    'Preparing': 'Đang chuẩn bị…',
    'RangeAll': 'Mọi lúc',
    'RangeAria': 'Khoảng thời gian',
    'RangeClose': 'Đóng',
    'RangeCustom': 'Tùy chọn',
    'RangeCustomOption': 'Tùy chọn…',
    'RangeCustomValue': 'Tùy chọn: {From} – {To}',
    'RangeFrom': 'Từ',
    'RangeLast30': '30 ngày qua',
    'RangeLast7': '7 ngày qua',
    'RangeTo': 'Đến',
    'RecordingNotOnDevice': 'Bản thu đó không có trên thiết bị này.',
    'RecordingRemoved': 'Bản thu đã bị xóa',
    'RemovalCountdownMany': 'Bản thu sẽ bị xóa sau {Days} ngày theo chính sách lưu giữ của chúng tôi.',
    'RemovalCountdownOne': 'Bản thu sẽ bị xóa sau {Days} ngày theo chính sách lưu giữ của chúng tôi.',
    'RemovalHint': 'Bạn có thể tải bản thu xuống để giữ lại, hoặc chỉnh cài đặt tự động xóa.',
    'RemovalHintLabel': 'Chi tiết lưu giữ',
    'RenameError': 'Không thể đổi tên lượt này. Vui lòng thử lại.',
    'RenameTakeAria': 'Đổi tên “{Name}”',
    'ReplaceThumbnail': 'Thay ảnh thu nhỏ',
    'ReplayAria': 'Phát bản thu này',
    'ReplayThumbnailAlt': 'Ảnh thu nhỏ của lượt — chạm để phát',
    'ReviewFailedNeverUploadedBody': 'Đánh giá này chưa từng chạy — bản ghi chưa bao giờ được tải lên. Hãy ghi lại lượt này để đánh giá.',
    'ReviewFailedNoCharge': 'Không giữ lại tín dụng nào — phần đã tạm giữ đã được hoàn lại.',
    'ReviewFailedNoCreditsBody': 'Bạn không đủ tín dụng AI để hoàn tất đánh giá này. Hãy nạp thêm rồi chạy lại.',
    'ReviewFailedOurSideBody': 'Lỗi này thuộc về chúng tôi — đánh giá không hoàn tất do sự cố phía chúng tôi, không phải lượt của bạn.',
    'ReviewFailedReRecord': 'Ghi lại',
    'ReviewFailedRecordingGoneBody': 'Đánh giá này chưa từng chạy — bản ghi đã bị xóa trước đó. Hãy ghi lại lượt này để đánh giá.',
    'ReviewFailedRetry': 'Đánh giá lại',
    'ReviewFailedTitle': 'Đánh giá AI chưa hoàn tất',
    'ReviewFailedTooLongBody': 'Lượt này dài {Measured}, vượt mức tối đa {MaxMinutes} phút để đánh giá. Hãy cắt ngắn và ghi lại.',
    'ReviewFailedTooShortBody': 'Lượt này dài {Measured}, dưới mức tối thiểu {MinSeconds} giây để đánh giá. Hãy ghi một lượt dài hơn rồi thử lại.',
    'ReviewFailedTopUp': 'Nạp tín dụng',
    'ReviewedPill': '★ Đã đánh giá',
    'ReviewedPillTitle': 'Có đánh giá AI',
    'Save': 'Lưu',
    'SaveError': 'Không thể lưu lượt này. Vui lòng thử lại.',
    'SaveNote': 'Lưu ghi chú',
    'SaveNoteError': 'Không thể lưu ghi chú của bạn. Vui lòng thử lại.',
    'SaveQuotaError': 'Bạn đã hết dung lượng — hãy dùng “Thêm dung lượng” ở trên, hoặc dọn bớt vài bản thu, rồi thử lại.',
    'SaveTitle': 'Lưu vào thư viện của tôi',
    'Saved': 'Đã lưu',
    'Saving': 'Đang lưu…',
    'ScrubAria': 'Tua đến một khung hình cho ảnh thu nhỏ',
    'ScrubCancel': 'Hủy',
    'SelectAll': 'Chọn tất cả',
    'SelectClear': 'Bỏ chọn',
    'SelectDone': 'Xong',
    'SelectTakeAria': 'Chọn “{Name}”',
    'SelectToggle': 'Chọn',
    'SelectedCount': 'Đã chọn {Count}',
    'SelectionAria': 'Các lượt đã chọn',
    'Subhead': 'Mọi lượt bạn đã thu — trên thiết bị này, trong kế hoạch thành thạo, đã lưu và đã đánh giá.',
    'TakeClose': 'Đóng',
    'TakeNext': 'Bản ghi sau',
    'TakePrevious': 'Bản ghi trước',
    'TakeStoredInCloud': 'Lưu trong thư viện đám mây của bạn',
    'TakeStoredOnDevice': 'Lưu trên thiết bị này',
    'TakesAria': 'Các lượt',
    'ThumbnailUploadError': 'Không thể cập nhật ảnh thu nhỏ. Vui lòng thử lại.',
    'UseThisFrame': 'Dùng khung hình này',
  },
} as const;

